export * from './banner/banner.component';
export * from './footer/footer.component';
export * from './nav/nav.component';
export * from './navmobile/navmobile.component';
export * from './title/title.component';
